var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 31,
    viewBox: "0 0 23 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-31.8%",
    y: "-16.7%",
    width: "163.6%",
    height: "146.7%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0853911713 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.001 2.834C.001 1.276 1.295 0 2.877 0h16.247C20.706 0 22 1.276 22 2.834v16.014c0 1.559-1.294 2.834-2.877 2.834h-3.494L10.999 30 6.37 21.682H2.876C1.294 21.682 0 20.407 0 18.847L.001 2.834z",
    id: "b"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    transform: "translate(.197 .98)"
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.303 5.943a3.405 3.405 0 0 1 3.4 3.4c0 1.878-1.528 3.416-3.4 3.416a3.405 3.405 0 0 1-3.401-3.401c0-1.878 1.528-3.415 3.4-3.415zm0 1.328a2.088 2.088 0 0 0-2.087 2.087c0 1.15.935 2.072 2.087 2.072a2.088 2.088 0 0 0 2.086-2.086c0-1.15-.935-2.073-2.086-2.073z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.302 11.43a5.296 5.296 0 0 0-5.291 5.292c0 .365.299.664.664.664a.666.666 0 0 0 .665-.664 3.979 3.979 0 0 1 3.976-3.977 3.979 3.979 0 0 1 3.977 3.977c0 .365.3.664.665.664a.634.634 0 0 0 .636-.669 5.295 5.295 0 0 0-5.292-5.287z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddress);
export default __webpack_public_path__ + "static/media/icon-address.c80eee418790a543523083a61410511d.svg";
export { ForwardRef as ReactComponent };